import moment from "moment";
import reportFormat from "@/pages/reports/tabs/report-format.mixin";

const onlyDigits = (value) => String(value || "").replace(/\D/g, "");

export default {
    mixins: [reportFormat],
    methods: {
        formatDateTime(value) {
            return value ? moment(value).format("DD/MM/YYYY HH:mm") : "--";
        },
        formatDuration(minutes) {
            if (!minutes) return "--";
            const hours = Math.floor(minutes / 60);
            const rest = minutes % 60;
            return hours ? `${hours}h${String(rest).padStart(2, "0")}` : `${rest} min`;
        },
        durationBetween(start, end) {
            if (!start || !end) return null;
            return Math.max(0, moment(end).diff(moment(start), "minutes"));
        },
        formatDistance(meters) {
            if (meters === null || meters === undefined) return "--";
            return meters >= 1000 ? `${this.num(meters / 1000)} km` : `${this.int(Math.round(meters))} m`;
        },
        notifyError(error, fallback = "Não foi possível concluir a operação.") {
            const data = error && error.response ? error.response.data : null;
            let message = null;
            if (data && Array.isArray(data.errors)) message = data.errors[0];
            else if (data && data.errors) message = Object.values(data.errors)[0][0];
            message = message || (data && data.message) || fallback;
            this.$store.dispatch("notification/add", { type: "error", message });
        },
        truncateText(text, length) {
            if (!text) return "";
            return text.length > length ? text.substring(0, length) + "..." : text;
        },
        formatPhone(phone) {
            const digits = onlyDigits(phone);
            if (digits.length === 11) return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
            if (digits.length === 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
            return phone || "--";
        },
        whatsappLink(phone) {
            const digits = onlyDigits(phone);
            return `https://api.whatsapp.com/send?phone=${digits.startsWith("55") ? digits : `55${digits}`}`;
        },
        statusOf(value) {
            return this.statusMap[value] || { label: value || "--", color: "" };
        },
    },
};
